import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AUTH_CLIENT_TOKEN, AuthClientProvider, LocalStorageKey } from '@core';
import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { ReassignGamePayload } from '../interfaces';

export const reassignGameResolver: ResolveFn<void> = (activatedRoute: ActivatedRouteSnapshot) => {
  const authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);

  const gameId: string = activatedRoute.params['gameId'];
  const token: string = activatedRoute.queryParamMap.get('token') as string;

  authClientProvider.isAuthed$
    .pipe(
      take(1),
      map((isAuthed: boolean) => {
        if (isAuthed) return sessionStorage.removeItem(LocalStorageKey.ReassignGame);

        const data: ReassignGamePayload = {
          gameId: gameId,
          token: token
        };

        return sessionStorage.setItem(LocalStorageKey.ReassignGame, JSON.stringify(data));
      })
    )
    .subscribe();
};
